import { render, staticRenderFns } from "./NotificationLog.vue?vue&type=template&id=165eea33&scoped=true&"
import script from "./NotificationLog.vue?vue&type=script&lang=js&"
export * from "./NotificationLog.vue?vue&type=script&lang=js&"
import style0 from "./NotificationLog.vue?vue&type=style&index=0&id=165eea33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165eea33",
  null
  
)

export default component.exports